var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-container"},[_c('button',{staticClass:"btn btn-default impersonate-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.impersonate(_vm.userId)}}},[_vm._v("\n        "+_vm._s(_vm.$t('admin.impersonateThisUser'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }